import { Base } from "../../framework/base";

export interface IGetTitle {
    getTitle(): string;
}

export interface IGetHash {
    getHash(): string;
}

export interface IIdGetTitle extends IGetTitle {
    id: string;
}

export interface IIdTitle extends IIdGetTitle {
    title: string;

    getHash(): string;
}

export class IdTitle implements IIdTitle {
    id: string;
    title: string;

    constructor();
    constructor(obj: IIdTitle);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.title = obj && obj.title || "";
    }

    static createIdTitle(id: string, title: string): IIdTitle {
        const result = new IdTitle();
        result.id = id;
        result.title = title;
        return result;
    }

    static createIdTitleSimple(text: string): IIdTitle {
        const result = new IdTitle();
        result.id = text;
        result.title = text;
        return result;
    }

    getTitle(): string {
        return this.title;
    }

    getHash(): string {
        return this.id + "#" + this.title;
    }

    static getHash(items: IGetHash[]): string {
        if (!items || items.length < 1) return "";
        return Base.joinSuffix(items.map(i => i.getHash()), "$");
    }

    static equal(a: IGetHash[], b: IGetHash[]): boolean {
        if (!a && !b) return true;
        if (!a || !b) return false;
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; i++) {
            if (a[i].getHash() !== b[i].getHash()) return false;
        }
        return true;
    }

    static getTitleById(items: IIdTitle[], id: string): string {
        if (!items || items.length < 1) return "";
        const item = items.find(i => i.id === id);
        return item?.title ?? "";
    }
            
    static getTitlesByIds(items: IIdTitle[], ids: string[]): string {
        if (!items || items.length < 1 || !ids || ids.length < 1) return "";
        const titles = items.filter(i => ids.includes(i.id)).map(i => i.title);
        return titles.join(", ");
    }
            
    static sortIdTitles(items: IIdGetTitle[], asc: boolean): IIdGetTitle[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: IIdGetTitle, b: IIdGetTitle) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.getTitle(), b.getTitle())); });
    }
}